/** The references object of all modules needed for components initialization */
var references = {
    'product' : require('_core_ext/pages/product'),
    'feefo' : require('_core_ext/pages/product/feefo'),
};

module.exports = {
    'references' : references
};
